module.exports = {
  i18n: {
    regions: ["中文", "English"],
    readBtn: "阅读更多",
    headerTopLeftMenus: [
      {
        name: "关于佳晟",
        path: "about",
      },
      {
        name: "工作机会",
        path: "CareerOpportunities",
      },
      {
        name: "下载",
        path: "/download",
      },
      {
        name: "佳晟荣誉",
        path: "/honor",
      },
      {
        name: "联系我们",
        path: "contactUs",
      },
    ],
    developementImg: require('../imgs/developmentHistory_zh.jpg'),
    PRESYSTitle:"PRESYS阀门",
    headerMain: {
      news: "新闻资讯",
      vacuumValve: "真空阀门",
      presys: "presys 阀门",
      productService: "产品服务",
      otherProducts: "其他产品",
    },
    headerMainChildren: {
      vacuumValve: "真空阀门",
      MGVAGV: "MGV/AGV",
      butterflyValve: "蝶阀",
      cornerValve: "角阀",
      highVacuumDirectValve: "高真空直通阀",
      UHV: "UHV角阀",
      rectangularValve: "传输阀",
      gate: "闸阀",
      highVacuumGateValve: "高真空闸阀",
      vacuumGateValve: "真空闸阀",
      combinedValve: "组合阀",
      presys: "presys 阀门",
      presysBriefIntroduction: "presys 简介",
      presysCourse: "presys 历程",
      valveRepairDndMaintenance: "阀门维修与保养",
      upgradeDndTransformation: "升级与改造",
      serviceCenter: "服务中心",
      Genius: "Genius 蝶阀",
      throttleValve: "Throttle Valve",
      throttleValveController: "Throttle Valve Controller",
      dualThrottleValve: "Dual Throttle Valve",
      multiPositionController: "Multi Position Controller",
      MNE: "MNE 密封圈O-RING",
      UNISEMChiller: "UNISEM chiller温控装置",
    },
    headerBottomLeftMenus: [
      {
        name: "新闻资讯",
        path: "/news",
        showDownArrow: false,
      },
      {
        name: "真空阀门",
        path: "",
        showDownArrow: true,
        children: [
          {
            name: "MGV/AGV",
            path: "",
          },
          {
            name: "蝶阀",
            path: "",
          },
          {
            name: "角阀",
            path: "",
            children: [
              {
                name: "高真空直通阀",
                path: "",
              },
              {
                name: "UHV角阀",
                path: "",
              },
            ],
          },
          {
            name: "传输阀",
            path: "",
          },
          {
            name: "闸阀",
            path: "",
            children: [
              {
                name: "高真空闸阀",
                path: "",
              },
              {
                name: "真空闸阀",
                path: "",
              },
            ],
          },
          {
            name: "组合阀",
            path: "",
          },
        ],
      },
      {
        name: "presys 阀门",
        path: "",
        showDownArrow: true,
      },
      {
        name: "产品服务",
        path: "",
        showDownArrow: true,
      },
      {
        name: "其他产品",
        path: "",
        showDownArrow: true,
      },
      {
        name: "查询",
        path: "",
        showSearch: true,
      },
    ],
    homeSwiperList: [
      {
        img: require("../imgs/1-nei.png"),
        imgS: require("../imgs/1-nei.png"),
        // img: require("../imgs/homeText.jpg"),
        imgP: require("../imgs/banner1.png"),
        about: "关于佳晟",
        title: "佳晟公司简介",
        path: "about",
        content:
          "靖江佳晟真空技术有限公司创立于2018年，专注于半导体高性能真空阀门研发的创新型科技企业。在创立之初，佳晟真空与韩国第一真空阀门公司PRESYS深入合作......",
      },
      {
        img: require("../imgs/2-nei.png"),
        imgS: require("../imgs/2-nei.png"),
        // img: require("../imgs/homeText2.jpg"),
        imgP: require("../imgs/banner2.png"),
        about: "产品服务",
        title: "佳晟.产品服务",
        path: "/valveRepairDndMaintenance",
        content:
          "以质量求发展，靠诚信行天下。 <br>助力客户价值提升是我们矢志不移的追求目标。",
        showStyle: true,
      },
      {
        img: require("../imgs/3-nei.png"),
        imgS: require("../imgs/3-nei.png"),
        // img: require("../imgs/homeTest3.jpg"),
        imgP: require("../imgs/banner3.png"),
        about: "新闻资讯",
        title: "presys.佳晟参展CSEAC2022无锡展会",
        path: "News",
        content:
          "第十届（CSEAC 2022）中国半导体设备年会暨半导体设备与核心部件展示会 2022年10月27日，一年一度的半导体行业盛会，在无锡太湖国际博览中心拉开帷幕。",
      },
    ],
    companyIntroduction: "佳晟公司简介",
    productServices: "佳晟-产品服务",
    description: "佳晟展会邀请",
    homeSearchTextOne: "寻找真空阀门",
    homeSearchTextTwo: "成千上万种真空阀门解决方案！找到您需要的解决方案！",
    homeSearchTextPlaceholder: "输入商品编号或产品名称",
    search: "输入商品编号或产品名称",
    newsVal: "最新资讯",
    companyConsultation: "公司咨询",
    downloadFile: "下载文件",
    downloadText: "需要阀门的CAD文件、操作说明、产品数据表或软件更新？",
    downloadTextTwo: "最常访问的网页：",
    downloadCenter: "下载中心",
    vacuumValve: "真空阀门",
    presys: "presys 阀门",
    genius: "Genius 蝶阀",
    otherProducts: "其他产品",
    CoreProducts: "核心产品",
    moreProducts: "更多产品",
    proList: [
      {
        img: require("../imgs/proImg1.png"),
        path: "VacuumValve3",
        about: "高真空角阀/直通阀",
      },
      {
        img: require("../imgs/proImg2.png"),
        path: "VacuumValve4",
        about: "UHV角阀",
      },
      {
        img: require("../imgs/proImg3.png"),
        path: "VacuumValve2",
        about: "蝶形控制阀",
      },
      {
        img: require("../imgs/proImg4.png"),
        path: "VacuumValve5",
        about: "传输阀",
      },
      {
        img: require("../imgs/proImg5.png"),
        path: "VacuumValve7",
        about: "真空闸阀",
      },
      {
        img: require("../imgs/proImg6.png"),
        path: "VacuumValve6",
        about: "高真空闸阀",
      },
      {
        img: require("../imgs/proImg7.png"),
        path: "VacuumValve8",
        about: "蝶阀和隔离阀",
      },
      {
        img: require("../imgs/proImg8.png"),
        path: "VacuumValve1",
        about: "手动/自动真空闸阀",
      },
    ],
    company: "佳晟真空",
    companyText:
      "佳晟真空专注于半导体高性能真空阀门研发。与韩国第一真空阀门公司PRESYS深入 合作，持续提供赢得客户感谢的产品与服务。优秀的创新与工程能力，是佳晟真空提供 技术与服务解决方案的原动力。 ",
    about: "关于佳晟",
    aboutText: "招贤纳士",
    learnMore: "了解更多",
    backHome: "返回顶部",
    footerList: [
      {
        name: "产品中心",
        path: "",
        children: [
          {
            name: "高真空角阀/直通阀",
            path: "VacuumValve3",
          },
          {
            name: "UHV角阀",
            path: "VacuumValve4",
          },
          {
            name: "蝶形控制阀",
            path: "VacuumValve2",
          },
          {
            name: "传输阀",
            path: "VacuumValve5",
          },
          {
            name: "真空闸阀",
            path: "VacuumValve7",
          },
          {
            name: "高真空闸阀",
            path: "VacuumValve6",
          },
          {
            name: "蝶阀和隔离阀",
            path: "VacuumValve8",
          },
          {
            name: "MGV / AGV",
            path: "VacuumValve1",
          },
        ],
        show: false,
      },
      {
        name: "产品服务",
        show: false,
        children: [
          {
            name: "阀门维修与保养",
            path: "valveRepairDndMaintenance",
          },
          {
            name: "升级与改造",
            path: "upgradeDndTransformation",
          },
          {
            name: "服务中心",
            path: "serviceCenter",
          },
        ],
      },
      /*{
        name: "其他产品",
        show: false,
        children: [
          // {
          //   name: "Throttle Valve",
          //   path: "throttleValve",
          // },
          // {
          //   name: "Throttle Valve Controller",
          //   path: "throttleValveController",
          // },
          // {
          //   name: "Dual Throttle Valve",
          //   path: "dualThrottleValve",
          // },
          // {
          //   name: "Multi Position Controller",
          //   path: "multiPositionController",
          // },
          {
            name: "MNE密封圈",
            path: "MNE",
          },
          {
            name: "chiller温控装置",
            path: "UNISEMChiller",
          },
        ],
      },*/
      {
        name: "关于真空阀的更多信息",
        show: false,
        children: [
          {
            name: "新闻资讯",
            path: "News",
          },
        ],
      },
      {
        name: "公司",
        show: false,
        children: [
          {
            name: "关于佳晟",
            path: "about",
          },
          {
            name: "工作机会",
            path: "CareerOpportunities",
          },
          {
            name: "佳晟荣誉",
            path: "honor",
          },
          {
            name: "联系我们",
            path: "contactUs",
          },
        ],
      },
      {
        name: "客户服务",
        show: false,
        children: [
          {
            name: "下载",
            path: "download",
          },
        ],
      },
    ],
    companyAbout:
    "2023 靖江佳晟真空技术有限公司 版权所有  工信部备案号：  ",
 
    home: "主页",
    news: "公司咨询",
    seeMore: "查看更多",
    // 佳晟荣誉
    honor: {
      name: "佳晟荣誉",
      subText: "团结奋进，共创辉煌",
    },
    // 下载
    downloadPage: {
      name: "下载文件",
      subText: "下载文件",
      brief:
        "您可以再此处找到产品的操作说明、技术数据表或3D step文件。要有产品名称或商品编号才能确定需要下载的文件。产品名称或商品编号可以直接在产品和交货单据上找到，也可以直接在本网站上的产品中找到。",
      titleList: [
        {
          index: 1,
          name: "真空阀门",
        },
        {
          index: 2,
          name: "presys 阀门",
        },
        // {
        //   index: 3,
        //   name: "Genius 蝶阀",
        // },
        {
          index: 4,
          name: "MNE密封圈",
        },
        {
          index: 5,
          name: "UNISEM chiller温控装置",
        },
      ],
    },
    properties: {
      size: "尺寸:",
      driver: "驱动器:",
      valveMaterialMaterial: "阀体材料:",
      feedingThrough: "馈通件:",
      StandardFlanges: "标准法兰:",
    },
    MGVAGVpro: {
      title: "手动/自动真空闸阀",
      homeTitle: "MGV/AGV",
      titleText:
        "用于高真空系统隔离的通用阀门。特别适用于泵隔离。高性价比的的波纹管密封阀，使用 寿命长。",
      size: 'DN 100-160 mm (4" to 6")',
      driver:
        "手动：带活动手轮 <br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;气动：双作用，带位置指示器",
      valveMaterialMaterial: "不锈钢",
      feedingThrough: "波纹管",
      StandardFlanges: "ISO-F，ISO- K",
      // downloadTitle: "蝶阀和隔离阀",
      downloadTitle: "手动/自动真空闸阀"
    },
    butterflyPro: {
      title: "蝶形控制阀",
      homeTitle: "蝶阀",
      titleText:
        "下游压力控制阀，用于SEMI、FPD、PV、SOLAR和工业制程。 最适用于快速和高要求工艺，如CVD。在脏污工艺中运行，可 靠出色的压力控制性能，服务端口用于连接计算器或服务箱。",
      size: "DN 100-200 (4”-8”)",
      driver: "带步进电机的集成压力控制器",
      valveMaterialMaterial: "铝或不锈钢",
      feedingThrough: "旋转馈通件",
      StandardFlanges: "ISO-F",
      downloadTitle: "蝶形控制阀",
    },
    highVacuumDirectValve: {
      title: "高真空直通阀",
      homeTitle: "角阀",
      titleText: "用于大气流真空系统的抽气和排气。耐高压差，使用寿命长。",
      size: "DN16-50 (5/8”-2”)",
      driver:
        "手动：带活动手轮 <br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;气动：单作用，带关闭弹簧(N.C.)或打开弹簧 <br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(N.O.)，或双作用",
      valveMaterialMaterial: "铝或不锈钢",
      feedingThrough: "波纹管",
      StandardFlanges: "ISO-KF,ISO-K",
      downloadTitle: "高真空直通阀",
    },
    UHV: {
      title: "UHV角阀",
      homeTitle: "角阀",
      titleText: "用于大气流真空系统的抽气和排气。耐高压差，使用寿命长。",
      size: "DN 16-63 (5/8”-2",
      driver:
        "手动：带活动手轮 <br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;气动：单作用，带关闭弹簧(N.C.)",
      valveMaterialMaterial: "不锈钢",
      feedingThrough: "波纹管",
      StandardFlanges: "CF-R",
      downloadTitle: "UHV角阀",
    },
    rectangularValve: {
      title: "传输阀",
      homeTitle: "传输阀",
      titleText:
        "受保护的波纹管，机械锁定在关闭位置，由机械引导固定的L型运动。",
      size: '46×236mm to 50×336mm(1.81"×9.29" to 1.97"×13.23")',
      driver: "气动：双作用，带位置指示器",
      valveMaterialMaterial: "铝",
      feedingThrough: "波纹管",
      downloadTitle: "传输阀",
    },
    highVacuumGateValve: {
      title: "高真空闸阀",
      homeTitle: "闸阀",
      titleText:
        "用于科研和工业领域真空隔离应用的标准阀门，购置成本低，用于直接安装的通孔(可选)， 分体式设计便于清洁，机械锁定于关闭位置。",
      size: 'DN 100-160 mm (4" to 6")',
      driver: "气动：双作用，带位置指示器",
      valveMaterialMaterial: "不锈钢",
      feedingThrough: "旋转轴馈通件",
      StandardFlanges: "ISO-F，cf-f",
      downloadTitle: "高真空闸阀",
    },
    vacuumGateValve: {
      title: "真空闸阀",
      homeTitle: "闸阀",
      titleText:
        "用于科研和工业领域真空隔离应用的标准阀门，购置成本低，用于直接安装的通孔(可选)， 分体式设计便于清洁，机械锁定于关闭位置。",
      size: 'DN 80-100 mm (3" to 4")',
      driver: "气动：双作用，带位置指示器",
      valveMaterialMaterial: "铝",
      feedingThrough: "波纹管",
      StandardFlanges: "ISO-F",
      downloadTitle: "真空闸阀",
    },
    combinedValve: {
      title: "蝶阀和隔离阀",
      homeTitle: "组合阀",
      titleText:
        "控制阀和隔离阀合二为一，结构紧凑，C1.0系列: B1.0系列蝶形控制阀和G1.0系列真空 闸阀。",
      size: "DN100 (4”)",
      driver: "带步进电机的集成压力控制器",
      valveMaterialMaterial: "不锈钢",
      feedingThrough: "铝",
      StandardFlanges: "ISO-F",
      downloadTitle: "蝶阀和隔离阀",
    },
    technicalData: "技术数据",
    download: "下载",
    backVacuum: "返回  真空阀门",
    next: "下一页",
    vacuumControlValveQa: "真空阀门的常见问答",
    vacuumControlValveQaList: [
      {
        title: "什么是真空阀门?",
        text:
          "真空阀门是一个安装在真空系统的供气或排气管道中的装置。\"它通常用于隔离真空区域，如工艺室，或控制进入和排出的气体量。真空阀门可以手动、气动、电子气动、电动或电磁方式操作。真空阀门是任何真空系统的一个组成部分，真空系统被广泛用于各种工业生产应用中。",
      },
      {
        title: "什么是高性能真空阀门?",
        text: ["某些真空工艺对工艺环境的纯度以及化学和物理稳定性有特别高的要求。例如，这适用于几乎所有的半导体生产领域，以及许多使用真空系统的研究设施。在基础研究领域，处理极端条件的能力，如非常高或低的温度、强辐射和压力高达10-15mbar的极高真空(XHV)--目前技术上可行和可测量的极限--常常被添加到这些要求中。",
          "这些应用中的真空阀门在以下方面与标准真空阀门不同:"],
        children: [
          {
            title: "最小化的颗粒排放",
            text: "高性能真空阀门经过优化，不会通过其外壳、机械装置或密封件的材料放出颗粒，也不会通过其开闭或控制运动的摩擦放出颗粒。这是通过对所用材料的特殊选择和处理，以及通过某些设计细节来实现的，这些细节可以最大限度地减少或在某些情况下完全消除粒子的释放。",
          },
          {
            title: "最小化的运动脉冲",
            text: "每一个阀门通过其开启和关闭运动产生运动脉冲。在自动驱动阀门的情况下，这些脉冲的范围可以从轻微的振动到可以听到和感知的硬冲击。这些运动脉冲可能会对敏感的制造工艺产生负面影响，例如，通过额外的颗粒释放。除了设计特点外，高性能真空阀主要通过控制所谓的运动曲线来减少这些脉冲。与乘客电梯的运行方式类似，在到达关闭点前不久，关闭速度会减慢，以防止\"撞击\"。这些运动曲线通常可以被修改，例如，在关闭时间和关闭频率方面，它们可以适应所需条件。",
          },
          {
            title: "中性化学和物理行为",
            text: "真空阀门总是改变真空工艺室的均匀性，无论其形式如何。这种情况的发生，部分是由于其几何形状的结果。流动路径的变窄或变宽可以改变流动阻力和流动速度，或者死角，如阀板的移动空间，可以促进沉积过程。这也是通过开启和关闭运动发生的，它改变了流动行为以及工艺气体的浓度、分布、混合和温度。高性能真空阀经过优化，尽可能地补偿这种影响，或使其可控。为此，在设计中加入了各种额外的技术，这些技术远远超出了阀门的基本功能。",
          },
        ]
      },
      {
        title: "真空阀门的类型有哪些?",
        text: ["真空阀门和其他阀门一样，使用一些基本的力学原理，如闸阀、挡板盘或旋转盘来分离或隔离真空区域并控制体积流量。然而，使用这些力学原理的基本条件是完全不同的。例如，高自由度的颗粒、精确控制非常小的体积流动、密封、最小的振动和冲击是至关重要的特性。因此，这些基本的机械装置通常为真空阀设计得不同。例如，关闭机构通常被设计为无摩擦地关闭，并引起最小的振动和冲击，如果有的话。此外，控制运动可以是极其精细的剂量，密封被优化，以便在理想情况下不释放任何颗粒，其静态或动态特性在长期使用中保持稳定。",
          "使用的真空阀门有以下基本类型:", "除了这些基本类型，还有大量的混合变体，其中一些结合了不同的阀门技术或为某些特殊要求提供解决方案。", "您想了解更多吗?", "请与我们联系，期待着与您沟通。"],
        children: [
          {
            title: "<span style='color: #990099'>真空闸阀</span>-通常是隔离或较简单的控制应用的理想选择。安装深度很窄，传导性最大(流阻\n" +
              "最小)，但闸门的行程空间需要。这些也可以采取真空狭缝阀、真空传输阀或真空门的形式，产品通过这些阀门被引入真空工艺室。",
          },
          {
            title: "<span style='color: #990099'>真空角阀</span>-通用的一般用途真空阀门。尺寸非常紧凑，通常在密封、执行器和传感器方面非常模块化。平均电导率，非常容易维护。非常好，如果需要的话，有非常精确的可控性。",
          },
          {
            title: "<span style='color: #990099'>真空蝶阀</span>-主要用于控制应用。非常窄的安装深度，良好的传导性，快速和精确的可控性。",
          },
          {
            title: "<span style='color: #990099'>真空摆阀</span>-非常窄的安装深度和紧凑的尺寸，结合非常精确的控制行为，非常好的绝缘能力和非常高的传导性。",
          },
          {
            title: "<span style='color: #990099'>对称流真空调节阀</span>-特殊类型，优化了从第一个开口到整个阀门开口的非常均匀的流动行为。",
          },
          {
            title: "<span style='color: #990099'>气体计量阀或漏气阀</span>-特别是对于非常精细的计量，例如，低流量的工艺气体的计量。",
          },
          {
            title: "<span style='color: #990099'>泄压阀或排气阀</span>-安全阀允许真空系统有控制地，通常是完全通风，并防止超过规定的压力条件。",
          },
          {
            title: "<span style='color: #990099'>真空止回阀</span>-被动式，体积流量和压差操作的阀门。通常用于保护真空系统免受倒流污染。例如，用于真空回流泵和真空系统之间。",
          },
          {
            title: "<span style='color: #990099'>快速闭合阀</span>-主动式保护阀，通常保护较大的真空体积或真空室不因泄漏而造成真空损失。主要特点:对检测到的压力下降有非常快的关闭反应。在UHV和XHV应用中，通常由扇形真空阀门(通常是真空闸阀)支持，以确保即使在非常高的压差下也能实现密封隔离。",
          },
          {
            title: "<span style='color: #990099'>真空全金属阀</span>-专为极端压力、温度和辐射条件设计的一组真空阀门。主要特点:硬对硬(金属对金属)的密封，而不是弹性密封，因为弹性密封无法承受服务条件。",
          },
          {
            title: "<span style='color: #990099'>真空多阀装置</span>-特殊类型的真空阀门，将几种真空阀门的功能结合在一个单元中。主要特点:减少部件数量，装配速度快。通常是根据客户要求定制。",
          },
          {
            title: "<span style='color: #990099'>3位真空阀门</span>-真空隔离阀的特殊形式，其中除了关闭和打开的位置外，还可以定义第三个阀位。例如，一种应用是为了避免在高压差时由于阀门打开过快而产生的压力脉冲。在第三个位置，密封圈上的接触压力在短时间内略微降低，而阀门却没有明显的打开，从而使压力变化更加平稳。",
          },
        ]
      },


    ],
    backPresys: "返回  PRESYS阀门",
    presysHomeList: [
      {
        path: "presysDetail",
        name: "presysy77",
        img: require("../imgs/presysv77.png"),
        title: "ATM Door <br>TRANSFER DOOR VALVE  SERIES V77 ",
        hidden: false,
        id:9
      },
      {
        path: "presysDetail",
        name: "presysy74",
        img: require("../imgs/presysv74.png"),
        title: "Transfer Valve <br>TRANSFER VALVE L-MO TION, SERIES V74",
        hidden: false,
        id:10
      },
      {
        path: "presysDetail",
        name: "presysy70",
        img: require("../imgs/presysv70.png"),
        title: "Transfer Valve <br>TRANSFER VALVE L-MO TION, SERIES V70 ",
        hidden: false,
        id:11
      },
      {
        path: "presysDetail",
        name: "presysy70Two",
        img: require("../imgs/presysv70Two.png"),
        title: "Transfer Valve <br>NON-STANDARD DOUB LE OPENING L-MOTION,  SERIES V70 ",
        hidden: false,
        id:12
      },
      {
        path: "presysDetail",
        name: "presysy70Three",
        img: require("../imgs/presysv70Three.png"),
        title: "Transfer Valve <br>NON-STANDARD FOUR  OPENING L-MOTION, S ERIES V70 ",
        hidden: false,
        id:13
      },
      {
        path: "presysDetail",
        name: "presysy72",
        img: require("../imgs/presysv72.png"),
        title: "Transfer Valve <br>ALL HEATING TRANSFE R VALVE L-MOTION, SE RIES V72",
        hidden: false,
        id:14
      },
      {
        path: "presysDetail",
        name: "presysy73",
        img: require("../imgs/presysv73.png"),
        title: "Transfer Valve <br>DOUBLE LAYER L-MOTI ON, SERIES V73",
        hidden: true,
        id:15
      },
      {
        path: "presysDetail",
        name: "presysy78",
        img: require("../imgs/presysv78.png"),
        title: "Transfer Valve <br>TRANSFER VALVE I-MOT ION, SERIES V78",
        hidden: true,
        id:16
      },
      {
        path: "presysDetail",
        name: "presysy20",
        img: require("../imgs/presysv20.png"),
        title: "GATE Valve <br>VACUUM GATE VALVE, S ERIES  V20",
        hidden: true,
        id:17
      },
      {
        path: "presysDetail",
        name: "presysy21",
        img: require("../imgs/presysv21.png"),
        title: "GATE Valve <br>HV GATE VALVE, SERIES  V21",
        hidden: true,
        id:18
      },
      {
        path: "presysDetail",
        name: "presysy21Two",
        img: require("../imgs/presysv21Two.png"),
        title: "Uhv Gate Valve <br>UHV GATE VALVE / 3-PO SITION, SERIES V21",
        hidden: true,
        id:19
      },
      {
        path: "presysDetail",
        name: "presysy21Three",
        img: require("../imgs/presysv21Three.png"),
        title: "Uhv Gate Valve <br>WITH HEAT JACKET,SERI ES V21 ",
        hidden: true,
        id:20
      },
      {
        path: "presysDetail",
        name: "presysy60",
        img: require("../imgs/presysv60.png"),
        title: "PTG Valve <br>HV PROTECTION GATE  VALVE, SERIES V60 ",
        hidden: true,
        id:21
      },
      {
        path: "presysDetail",
        name: "presysy41",
        img: require("../imgs/presysv41.png"),
        title: "RPC Angle Valve  <br>REMOTE PLASMA CONT ROL VALVE , SERIES V41 ",
        hidden: true,
        id:22
      },
      {
        path: "presysDetail",
        name: "presysy75",
        img: require("../imgs/presysv75.png"),
        title: "Large Transfer Valve  <br>LARGE TRANSFER VALVE/ DOOR L-MOTION, SERIES  V75 ",
        hidden: true,
        id:23
      },
      {
        path: "presysDetail",
        name: "presysy76",
        img: require("../imgs/presysv76.png"),
        title: "Large Transfer Valve  <br>LARGE TRANSFER VALVE/ INSERT T-MOTION, SERIE S V76",
        hidden: true,
        id:24
      },
    ],
    backTop: "回到顶部",
    PresysBriefIntroduction: "PRESYS简介",
    PresysBriefIntroductionTitle: "全球领先供应商PRESYS",
    PresysBriefIntroductionText: "专注于半导体高性能真空阀门研发的创新型科技企业。",
    PresysBriefIntroductionList: [
      {
        title: "公司名称：",
        text: "PRESYS Co.LTD/PRESYS INC",
      },
      {
        title: "CEO：",
        text: "Jun Choen，Seo",
      },
      {
        title: "成立日期：",
        text: "1997年6月",
      },
      {
        title: "资本：",
        text: "17亿韩元",
      },
      {
        title: "员工人数：",
        text: "120",
      },
      {
        title: "地址：",
        text: "(441-813)1433-64",
      },
      {
        title: "地址：",
        text: "(441-813)1433-64，Sewu-ro，Gwonseon-qu，韩国京畿道水原市",
      },
      {
        title: "联系电话：",
        text: "+82-31-8003-1133(总部) / +82-31-8003-5100(直达号码)",
      },
      {
        title: "传真：",
        text: "+82-31-8003-3399(总部) / +82-31-8003-2849(直接编号)",
      },
      {
        title: "其他：",
        text: "95知识产权和专利注册及申请",
      },
    ],
    presysProcess: "PRESYS历程",
    presysProcessList: [
      {
        year: "2020",
        textList: [
          "知识产权经营企业 / 专利厅",
          "China Marketing Start (with Agent)"
        ]
      },
      {
        year: "2018",
        textList: [
          "入选2017年度全球明星风险投资培育项目",
          "(中小企业厅，韩国风险投资协会)"
        ]
      },
      {
        year: "2016",
        textList: [
          "认证 IBK 技术强小企业",
          "国外分公司成立与运营(美国硅谷)"
        ]
      },
      {
        year: "2015",
        textList: [
          "Foundry 企业注册",
          "美国 AMAT(应用材料)企业注册"
        ]
      },
      {
        year: "2014",
        textList: [
          "认证 IBK 技术强效企业",
          "三星电子指定专门培训真空阀门的公司(培养零部件专家)",
          "获得 OHSAS 18001(安全保健系统)认证",
          "水原产业园区(风险投资促进机构)新建搬迁",
        ]
      },
      {
        year: "2013",
        textList: [
          "获得 |S0 14001 认证",
        ]
      },
      {
        year: "2011",
        textList: [
          "Fujikin(日本)-签订了PRESYS的代理商",
        ]
      },
      {
        year: "2009",
        textList: [
          "面向京畿中小企业的半导体装备新技术革新领域获奖",
          "再次获得技术革新中小企业(INNOBIZ)确认书"
        ]
      },
      {
        year: "2007",
        textList: [
          "公司变更为 PRESYS Co., Ltd.",
          "Kurtl.Lesker(美国/欧洲)-签订了PRESYS的代理商"
        ]
      },
      {
        year: "2006",
        textList: [
          "KOBO A+N Member 评选/技术革新型中小企业认证(INNOBIZ 认证)",
        ]
      },
      {
        year: "2004",
        textList: [
          "成长动力新一代半导体新技术开发事业执行企业选定(产业资源部)",
          "选定技术革新事业执行企业(中小企业厅)",
        ]
      },
      {
        year: "2003",
        textList: [
          "获得 1S0 9001 认证",
        ]
      },
      {
        year: "2002",
        textList: [
          "京畿道市长表彰/优秀技术企业评选(技术信用保证基金)",
          "加入韩国真空学会会员公司",
        ]
      },
      {
        year: "2001",
        textList: [
          "开发 Ultra Dry Cleaning System/认证企业敷设研究说",
        ]
      },
      {
        year: "2000",
        textList: [
          "风险企业获奖/大韩民国",
          "加入韩国半导体行业协会会员公司(KSIA)",
          "优秀技术大奖(中小企业厅)",
        ]
      },
      {
        year: "1997",
        textList: [
          "创立STS CO., Ltd.",
        ]
      },
    ],
    backHomePage: "返回首页",
    APPLICATIONS: "APPLICATIONS",
    MAINFEATURES: "MAIN FEATURES",
    OPTIONS: "OPTIONS",
    presysDetailList: [
      {
        id: 9,
        name: "presysy77",
        bgImg: require("../imgs/ban_bgs.png"),
        bgImgP:  require("../imgs/v77Bg-p.png"),
        img: require("../imgs/v77DetailImg.png"),
        downloadImg: require("../imgs/v77DetailDwonloadImg.png"),
        downloadTitle: "ATM Door",
        downloadText: "TRANSFER DOOR VALVE,  SERIES V77",
        title: "ATM Door",
        titleTwo: "TRANSFER DOOR VALVE,  SERIES V77",
        text: "For load lock and process chamber isolation on the atmosphericside of SEMl production system. Also suitable for PV in-line system.",
        applications: [
          "Semiconductor processing","Plasma Etch, CVD, sputter deposition","Manufacturing of solar panels","LCD / flat panel process","All other cluster and in-line vacuum systems"
        ],
        mainFeatures: [
          "Semi standard application (Semi E21- 94, SemiE24-92, Semi- E21.1-1296) ",
          "Dust seal on the vacuum side of the bonnet flangethat virtually eliminat-es particulate from enteringthe bellows Mechanical lock at the close pos-ition",
          "Particle and vibration free",
          "Realization of exact L-motion",
          "Easy maintenance"
        ],
        options: [
          "Hard anodize","Custom opening size available","Various O-ring (Kalrez® ,Chemraz® etc.)"
        ],
      },
      {
        id: 10,
        name: "presysy74",
        bgImg: require("../imgs/v74.png"),
        bgImgP:  require("../imgs/v74Bg-p.png"),
        img: require("../imgs/v74DetailImg.png"),
        downloadImg: require("../imgs/v74DetailDwonloadImg.png"),
        downloadTitle: "Transfer Valve",
        downloadText: "TRANSFER VALVE L-MOTION, SERIES V74",
        title: "Transfer Valve",
        titleTwo: "TRANSFER VALVE L-MOTION, SERIES V74",
        text: "For load lock and process chamber isolation in SEMI production  system. Suitable for corrosive process such as Etch or CVD.",
        applications: [
          "Semiconductor processing",
          "Plasma Etch, CVD, sputter deposition",
          "Manufacturing of solar panels","LCD / flat panel process","All other cluster and in-line vacuum systems"
        ],
        mainFeatures: [
          "Semi standard application (Semi E21- 94, SemiE24-92, Semi- E21.1-1296) ",
          "Patented L-motion link and dual shifts without springs in the actuator enable faster,smoother actuation with siqnificantly reduced vibrationSingl-e pneumatic actuator",
          "Mechanical lock at the close position",
          "Welded bellows actuator seal",
          "Bonnet flange bolts are designed with retainers to eliminate bolts from fa-lling out upon disassembly"
        ],
        options: [
          "Custom opening size available","Stainless steel solution","Various O-ring (Kalrez® ,Chemraz® etc.)"
        ],
      },
      {
        id: 11,
        name: "presysy70",
        bgImg: require("../imgs/v70.png"),
        bgImgP:  require("../imgs/v70Bg-p.png"),
        img: require("../imgs/v70DetailImg.png"),
        downloadImg: require("../imgs/v70DetailDownloadImg.png"),
        downloadTitle: "Transfer Valve",
        downloadText: "TRANSFER VALVE L-MOTION, SERIES V70",
        title: "Transfer Valve",
        titleTwo: "TRANSFER VALVE L-MOTION, SERIES V70",
        text: "For load lock and process chamber isolation in SEMI production  system. Suitable for corrosive proc",
        applications: [
          "Semiconductor processing","Plasma Etch, CVD, sputter deposition","Manufacturing of solar panels","LCD / flat panel process","All other cluster vacuum systems"
        ],
        mainFeatures: [
          "Semi standard application (Semi E21- 94, SemiE24-92, Semi- E21.1-1296) ",
          "Low vibration.Patented L-motion link and dual shifts without springs inthe actuator enable faster,smoother actuatione ",
          "Mechanical lock at the close position",
          "Welded bellows actuator seal",
          "Bonnet flange bolts are designed with retainers to eliminate bolts from fa-lling out upon disassembly"
        ],
        options: [
          "Hard anodize","Stainless steel solution", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.)"
        ],
      },
      {
        id: 12,
        name: "presysy70Two",
        bgImg: require("../imgs/v70-1.png"),
        bgImgP:  require("../imgs/v70TwoBg-p.png"),
        img: require("../imgs/v70TwoDetailImg.png"),
        downloadImg: require("../imgs/v70TwoDetailDwonloadImg.png"),
        downloadTitle: "Transfer Valve",
        downloadText: "NON-STANDARD DOUBLE OPENING L- MOTION, SERIES V70",
        title: "Transfer Valve",
        titleTwo: "NON-STANDARD DOUBLE OPENING L- MOTION, SERIES V70",
        text: "For load lock and process chamber isolation in SEMI production  system. Suitable for corrosive proc",
        applications: [
          "Semiconductor processing","Plasma Etch, CVD, sputter deposition","Manufacturing of solar panels","LCD / flat panel process","All other cluster vacuum systems"
        ],
        mainFeatures: [
          "Semi standard application (Semi E21- 94, SemiE24-92, Semi- E21.1-1296) ",
          "Low vibration.Patented L-motion link and dual shifts without springs inthe actuator enable faster,smoother actuatione ",
          "Mechanical lock at the close position",
          "Welded bellows actuator seal",
          "Bonnet flange bolts are designed with retainers to eliminate bolts from fa-lling out upon disassembly"
        ],
        options: [
          "Hard anodize", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.)"
        ],
      },
      {
        id: 13,
        name: "presysy70Three",
        bgImg: require("../imgs/v70-2.png"),
        bgImgP:  require("../imgs/v70ThreeBg-p.png"),
        img: require("../imgs/v70ThreeDetailImg.png"),
        downloadImg: require("../imgs/v70ThreeDetailDwonloadImg.png"),
        downloadTitle: "Transfer Valve",
        downloadText: "NON-STANDARD FOUR OPENING L- MOTION, SERIES V70",
        title: "Transfer Valve",
        titleTwo: "NON-STANDARD FOUR OPENING L- MOTION, SERIES V70",
        text: "For load lock and process chamber isolation in SEMI production  system. Suitable for corrosive proc",
        applications: [
          "Semiconductor processing","Plasma Etch, CVD, sputter deposition","Manufacturing of solar panels","LCD / flat panel process","All other cluster vacuum systems"
        ],
        mainFeatures: [
          "Semi standard application (Semi E21- 94, SemiE24-92, Semi- E21.1-1296) ",
          "Low vibration.Patented L-motion link and dual shifts without springs inthe actuator enable faster,smoother actuatione ",
          "Mechanical lock at the close position",
          "Welded bellows actuator seal",
          "Bonnet flange bolts are designed with retainers to eliminate bolts from fa-lling out upon disassembly"
        ],
        options: [
          "Hard anodize", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.)"
        ],
      },
      {
        id: 14,
        name: "presysy72",
        bgImg: require("../imgs/v72.png"),
        bgImgP:  require("../imgs/v72Bg-p.png"),
        img: require("../imgs/v72DetailImg.png"),
        downloadImg: require("../imgs/v72DetailDwonloadImg.png"),
        downloadTitle: "Transfer Valve",
        downloadText: "ALL HEATING TRANSFER VALVE L- MOTION, SERIES V72",
        title: "Transfer Valve",
        titleTwo: "ALL HEATING TRANSFER VALVE L- MOTION, SERIES V72",
        text: "For load lock and process chamber isolation in SEMI production  system. Suitable for corrosive proc",
        applications: [
          "Semiconductor processing",
          "Plasma Etch, CVD, sputter deposition",
          "Manufacturing of solar panels",
          "LCD / flat panel process",
          "All other cluster vacuum systems"
        ],
        mainFeatures: [
          "Semi standard application (Semi E21- 94, SemiE24-92, Semi- E21.1-1296) ",
          "Low vibration.Patented L-motion link and dual shifts without springs inthe actuator enable faster,smoother actuatione ",
          "Mechanical lock at the close position",
          "Welded bellows actuator seal",
          "Bonnet flange bolts are designed with retainers to eliminate bolts from fa-lling out upon disassembly"
        ],
        options: [
          "Hard anodize", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.)"
        ],
      },
      {
        id: 15,
        name: "presysy73",
        bgImg: require("../imgs/v73.png"),
        bgImgP:  require("../imgs/v73Bg-p.png"),
        img: require("../imgs/v73DetailImg.png"),
        downloadImg: require("../imgs/v73DetailDwonloadImg.png"),
        downloadTitle: "Transfer Valve",
        downloadText: "DOUBLE LAYER L-MOTION, SERIES V73",
        title: "Transfer Valve",
        titleTwo: "DOUBLE LAYER L-MOTION, SERIES V73",
        text: "For load lock and process chamber isolation in SEMI production  system. Suitable for corrosive process such as Etch or CVD.",
        applications: [
          "Semiconductor processing",
          "Plasma Etch, CVD, sputter deposition",
          "Manufacturing of solar panels",
          "LCD / flat panel process",
          "All other cluster vacuum systems"
        ],
        mainFeatures: [
          "Semi standard application (Semi E21- 94, SemiE24-92, Semi- E21.1-1296) ",
          "Low vibration.Patented L-motion link and dual shifts without springs inthe actuator enable faster,smoother actuatione ",
          "Mechanical lock at the close position",
          "Welded bellows actuator seal",
          "Bonnet flange bolts are designed with retainers to eliminate bolts from fa-lling out upon disassembly"
        ],
        options: [
          "Hard anodize", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.)"
        ],
      },
      {
        id: 16,
        name: "presysy78",
        bgImg: require("../imgs/v78.png"),
        bgImgP:  require("../imgs/v78Bg-p.png"),
        img: require("../imgs/v78DetailImg.png"),
        downloadImg: require("../imgs/v78DetailDwonloadImg.png"),
        downloadTitle: "Transfer Valve",
        downloadText: "TRANSFER VALVE I-MOTION, SERIES V78 ",
        title: "Transfer Valve",
        titleTwo: "TRANSFER VALVE I-MOTION, SERIES V78 ",
        text: "For load lock and process chamber isolation in SEMI production  system. Suitable for corrosive process such as Etch or CVD.",
        applications: [
          "Semiconductor processing",
          "Pneumatically locked (option)",
          "Plasma Etch, CVD, sputter deposition",
          "Manufacturing of solar panels",
          "LCD / flat panel process"
        ],
        mainFeatures: [
          "Semi standard application (Semi E21- 94, SemiE24-92, Semi- E21.1-1296) ",
          "Low vibration",
          "Long lifetime",
          "Pneumatically locked (option)",
          "Welded bellows actuator seal",
          "Bonnet flange bolts are designed with retainers to eliminate bolts from fa-lling out upon disassembly"
        ],
        options: [
          "Hard anodize", "Stainless steel solution", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.)"
        ],
      },
      {
        id: 17,
        name: "presysy20",
        bgImg: require("../imgs/v20.png"),
        bgImgP:  require("../imgs/v20Bg-p.png"),
        img: require("../imgs/v20DetailImg.png"),
        downloadImg: require("../imgs/v20DetailDwonloadImg.png"),
        downloadTitle: "GATE Valve",
        downloadText: "VACUUM GATE VALVE, SERIES  V20",
        title: "GATE Valve",
        titleTwo: "VACUUM GATE VALVE, SERIES  V20",
        text: "The standard valve for vacuum isolation application in industry and research.",
        applications: [
          "General vacuum, solar, semiconductor processing",
          "PVD, sputter deposition",
        ],
        mainFeatures: [
          "Low cost of ownership",
          "Good O-ring shaft sealed valve",
          "Shock free with minimum vibration",
          "Aluminum material valve body",
          "Mechanical lock in close position while air failure",
          "DN40-320 with FKM O-ring gate seal",
          "Pneumatic actuators double action",
          "Available in ISO-K, ISO-F metric flange options",
        ],
        options: [
          "Custom specified flange", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.) "
        ],
      },
      {
        id: 18,
        name: "presysy21",
        bgImg: require("../imgs/v21.png"),
        bgImgP:  require("../imgs/v21Bg-p.png"),
        img: require("../imgs/v21DetailImg.png"),
        downloadImg: require("../imgs/v21DetailDwonloadImg.png"),
        downloadTitle: "GATE Valve",
        downloadText: "HV GATE VALVE, SERIES V21",
        title: "GATE Valve",
        titleTwo: "HV GATE VALVE, SERIES V21",
        text: "General purpose for high vacuum isolation. Especially suit to pump isolation. ",
        applications: [
          "General vacuum, solar, semiconductor processing",
          "PVD, sputter deposition",
        ],
        mainFeatures: [
          "Good bellow sealed valve",
          "Shock free with minimum vibration",
          "Stainless steel material valve body for corrosion resistance",
          "Mechanical lock in close position ",
          "DN63-630 with FKM O-ring gate seal",
          "Pneumatic, manual and 3-Position actuators",
          "Available in ISO-F, CF-F, ASA-LP, JIS flange",
        ],
        options: [
          "Custom specified flange", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.) "
        ],
      },
      {
        id: 19,
        name: "presysy21Two",
        bgImg: require("../imgs/v21-1.png"),
        bgImgP:  require("../imgs/v21TwoBg-p.png"),
        img: require("../imgs/v21TwoDetailImg.png"),
        downloadImg: require("../imgs/v21TwoDetailDwonloadImg.png"),
        downloadTitle: "GATE Valve",
        downloadText: "UHV GATE VALVE / 3-POSITION, SERIES V21",
        title: "GATE Valve",
        titleTwo: "UHV GATE VALVE / 3-POSITION, SERIES V21",
        text: "General purpose for ultra high vacuum isolation applications in research and industry. Especially suit to pump isolation",
        applications: [
          "Research, semiconductor, solar, general vacuum processing ",
          "PVD, CVD, sputter deposition",
        ],
        mainFeatures: [
          "Good bellow sealed valve",
          "Shock free with minimum vibration",
          "Stainless steel material valve body for corrosion resistance",
          "Mechanical lock in close position ",
          "DN63-320 with FKM O-ring gate seal",
          "Pneumatic, manual and 3-Position actuators",
          "Available in ISO-F, CF-F, ASA-LP, JIS flange",
        ],
        options: [
          "Custom specified flange", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.) "
        ],
      },
      {
        id: 20,
        name: "presysy21Three",
        bgImg: require("../imgs/v21-2.png"),
        bgImgP:  require("../imgs/v21ThreeBg-p.png"),
        img: require("../imgs/v21ThreeDetailImg.png"),
        downloadImg: require("../imgs/v21ThreeDetailDwonloadImg.png"),
        downloadTitle: "GATE Valve",
        downloadText: "WITH HEAT JACKET,SERIES V21",
        title: "GATE Valve",
        titleTwo: "WITH HEAT JACKET,SERIES V21",
        text: "General purpose for ultra high vacuum isolation applications in research and industry. Especially suit to pump isolation",
        applications: [
          "Research, semiconductor, solar, general vacuum processing ",
          "PVD, CVD, sputter deposition",
        ],
        mainFeatures: [
          "Good bellow sealed valve",
          "Shock free with minimum vibration",
          "Stainless steel material valve body for corrosion resistance",
          "resistance",
          "Mechanical lock in close position ",
          "DN63-320 with FKM O-ring gate seal",
          "Pneumatic, manual and 3-Position actuators",
          "Available in ISO-F, CF-F, ASA-LP, JIS flange",
        ],
        options: [
          "Custom specified flange", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.) "
        ],
      },
      {
        id: 21,
        name: "presysy60",
        bgImg: require("../imgs/v60.png"),
        bgImgP:  require("../imgs/v60Bg-p.png"),
        img: require("../imgs/v60DetailImg.png"),
        downloadImg: require("../imgs/v60DetailDwonloadImg.png"),
        downloadTitle: "PTG Valve",
        downloadText: "HV PROTECTION GATE VALVE, SERIES V60",
        title: "PTG Valve",
        titleTwo: "HV PROTECTION GATE VALVE, SERIES V60",
        text: "General purpose for high vacuum protection and isolation. Especially  suit to protection and isolation between chamber and pump.",
        applications: [
          "Semiconductor processing",
          "Vacuum pump or chamber isolation in demanding processes",
          "Etch, CVD (MO, PE, HDP, LP) implant, sputter",
          "Nanotechnology process with high particulate levels",
          "Thin film photovoltaic panels",
        ],
        mainFeatures: [
          "Protects process environment from ",
          "down-streaming powder in the event of dry pump ",
          "failure ",
          "Fast pneumatic open & close less than 0.3s",
          "Long cycle life under adverse process conditions",
          "Integrated or independent controller with LCD ",
          "display",
          "Easy routine maintenance ",
        ],
        options: [
          "Independent control of protection ring",
          "1,2,3 or 4 channel control on request",
          "UPS on request",
          "Heat jacket",
        ],
      },
      {
        id: 22,
        name: "presysy41",
        bgImg: require("../imgs/v40.png"),
        bgImgP:  require("../imgs/v41Bg-p.png"),
        img: require("../imgs/v41DetailImg.png"),
        downloadImg: require("../imgs/v41DetailDwonloadImg.png"),
        downloadTitle: "RPC Angle Valve",
        downloadText: "REMOTE PLASMA CONTROL VALVE , SERIES V41",
        title: "RPC Angle Valve",
        titleTwo: "REMOTE PLASMA CONTROL VALVE , SERIES V41",
        text: "For upstream cleaning air inflow chamber in SEMI production system. Suitable  for Etch, CVD process.",
        applications: [
          "Semiconductor processing",
          "All CVD process (including MO, PE, HDP, LP and AP)",
          "Manufacturing of solar process",
          "All other cluster and in-line vacuum systems",
        ],
        mainFeatures: [
          "Semi standard application (Semi E21- 94, SemiE24-92, Semi- E21.1-1296) ",
          "Particle free, provide extremely clean updream air inflow chamber",
          "1 million service life cycles",
          "High vacuum angle valve",
          "Pneumatic actuator, double action",
          "Smart and modularization design, easy maintenance",
        ],
        options: [
          "White hard anodized surface treatment ",
          "Custom opening size available",
          "Various O-ring (Kalrez® ,Chemraz® etc.) ",
        ],
      },
      {
        id: 23,
        name: "presysy75",
        bgImg: require("../imgs/v75.png"),
        bgImgP:  require("../imgs/v75Bg-p.png"),
        img: require("../imgs/v75DetailImg.png"),
        downloadImg: require("../imgs/v75DetailDwonloadImg.png"),
        downloadTitle: "Large Transfer Valve",
        downloadText: "LARGE TRANSFER VALVE/DOOR L -MOTION, SERIES V75",
        title: "Large Transfer Valve",
        titleTwo: "LARGE TRANSFER VALVE/DOOR L -MOTION, SERIES V75",
        text: "For in-line process chamber isolation in solar, FPD production system.",
        applications: [
          "Solar, FPD processing ",
          "Plasma Etch, CVD, sputter deposition",
          "LCD / flat panel processing",
          "All other application that require pressure controller vacuum systems",
        ],
        mainFeatures: [
          "Reduced vibration significantly by using patented L  -motion link and dual shifts without springs in the actuator enable faster, smoother actuation",
          "Mechanical lock at the close position",
          "Welded bellows actuator seal ",
          "Bonnet flange bolts are designed with retainers to eliminate bolts from falling out upon disassembly",
          "Pneumatic actuator double action",
        ],
        options: [
          "Hard anodize",
          "Stainless steel solution",
          "Various O-ring (Kalrez® ,Chemraz® etc.) ",
        ],
      },
      {
        id: 24,
        name: "presysy76",
        bgImg: require("../imgs/v76.png"),
        bgImgP:  require("../imgs/v76Bg-p.png"),
        img: require("../imgs/v76DetailImg.png"),
        downloadImg: require("../imgs/v76DetailDwonloadImg.png"),
        downloadTitle: "Large Transfer Valve",
        downloadText: "LARGE TRANSFER VALVE/INSERT  T-MOTION, SERIES V76",
        title: "Large Transfer Valve",
        titleTwo: "LARGE TRANSFER VALVE/INSERT  T-MOTION, SERIES V76",
        text: "For in-line process chamber isolation in solar, FPD production system.",
        applications: [
          "Solar, FPD processing",
          "Low shock at high operation speed",
          "position 3 allows to keep one chamber under vacuum while  maintenance work is carried out on the valve",
          "LCD / flat panel processing",
        ],
        mainFeatures: [
          "Reduced vibration significantly by using patented T-motion sealing technology",
          "Mechanical lock function is applied",
          "Welded bellows actuator seal ",
          "Bonnet flange bolts are designed with retainers to eliminate bolts from falling out upon disassembly",
          "Pneumatic actuator double action",
        ],
        options: [
          "Hard anodize",
          "Stainless steel solution",
          "Custom opening size available",
          "Various O-ring (Kalrez® ,Chemraz® etc.) ",
        ],
      },
    ],
    productService: "产品服务",
    valveRepairDndMaintenance: "阀门维修与保养",
    valveRepairDndMaintenanceTitle: "增加了系统的稳定性和优化了运行时间",
    valveRepairDndMaintenanceText: "我们保持你的系统运行。<br>佳晟真空维修与保养服务 在全国范围内为您提供。<br>你需要一个不定期的快速维修。 <br>你想用服务合同来支持你的生产。<br>请与我们联系。",
    valveRepairDndMaintenanceMainTitle: "快速、高质量且有质量保证",
    valveRepairDndMaintenanceMainText: "为了保证阀门的正常使用，定期维修和保养是非常重要的。我们会为用户提供常规维修和保养服务,包括清洗、检修、润滑、更换配件等。针对特殊情况，比如温度和压力异常、发现损坏等，我们也会提供相应的应急维修服务。<br><br>" +
      "用户遇到的故障问题，我们会有专业的技术人员进行排查，根据故障的具体情况提供解决方案。针对不同情况，选取最适合用户需要的方案实施。故障得到解决，再进行验收，确保阀门的使用安全。<br><br>" +
      "随着科技进步和行业的不断发展，阀门的技术水平也在不断提高。我们会根据市场需求和技术发展，提供相应的升级和优化方案，以提高阀门的性能和使用寿命。",
    contactUs: "联系我们",
    upgradeDndTransformation: "升级与改造",
    upgradeDndTransformationTitle: "升级和改造解决方案",
    upgradeDndTransformationText: "与创新和不断变化的生产要求保持同步。<br>高科技 制造业是一个不断创新和成本优化的循环。<br> 因此，生产能力不断发展以满足最新的要求。",
    upgradeDndTransformationMainTitle: "为了实现更高的产量和更高的收益",
    upgradeDndTransformationMainTitleTwo: "佳晟真空的真空阀门升级和改造方案可以帮助实现提高产量、降低运营成本和更快的整体投资回报，以及具有更多的优势:",
    upgradeDndTransformationTextList: [
      "改进（更快、更精确的控制）阀门性能，提高生产效率","改善颗粒性能","延长正常运行时间","快速和方便的维护", "\"即插即用\"的解决方案"
    ],
    serviceCenter: "服务中心",
    serviceCenterTitle: "佳晟真空服务中心",
    serviceCenterText: "如有需要，请与我们联系。",
    serviceCenterMainTitle: "您是否在寻找真空阀门系统维护方面的帮助？ ",
    serviceCenterMainText: "我们正在不断扩大服务中心网络，以保证我们的客户得到快速服务。除了在我们的服 务中心维修系统和设备外，如有需要，我们的灵活服务团队也提供现场服务。",
    contactNumber: "联系电话：0523-82058068",
    email: "邮箱：jjhr@jiajiaprecise.com",
    address: "地址：江苏省靖江市经济技术开发区新兴路9号",
    throttleValveTitle: "Genius 蝶阀",
    throttleValveText: "Main product of our company : Throttle Valve & Controller",
    throttleValveTable: [
      {
        name: "Flapper type/阀贩",
        text: "Round(Butterfly), Combination,Blade"
      },
      {
        name: "Round type flapper size(lD)/圆监网版尺寸(D)",
        text: "25mm~300mm(Non-sealing type) <br> 25mm~160mm (Sealing type) <br> 40mm-100mm(Heating type)"
      },
      {
        name: "Combination type flapper size(ID)/组合型间板尺寸(D)",
        text: "100mm~300mm"
      },
      {
        name: "Blade type flapper size(lD)片型阀板尺寸(ID)",
        text: "200mm-1000mm"
      },
      {
        name: "Max temperature on Valve body/阀体工作范围",
        text: "Standard 0℃~100\"C(0ptional:up to 200°C)"
      },
      {
        name: "Max temperature on Valve motor/阀门电机温度范围",
        text: "-20℃-50℃"
      },
      {
        name: "From open to close time /完全闭合时间",
        text: "Less than 1.5sec"
      },
      {
        name: "Resolution/分辨率",
        text: "1/28,800"
      },
      {
        name: "Drive method/传动方式",
        text: "Direct gear drive /齿轮传动"
      },
      {
        name: "External leakage at shaft seal/轴封外泄率",
        text: "1x10cc/sec,He"
      },
      {
        name: "Material exposed to process/工艺接触材料",
        text: "AL,SUS.Viton(Standard)"
      },
      {
        name: "Low particle/较少的颗粒",
        text: "Tefron bushing"
      },
      {
        name: "Compatible pressure controller /可兼容压力控制",
        text: "GT-800.GT-700.MKS 651"
      },
      {
        name: "Flange type/法兰型号",
        text: "NW,ISO,JIS, ANSI(ASA),CF"
      },
    ],
    throttleValveControllerTitle: "Throttle Valve Controller",
    throttleValveControllerText: [
      "<span style='color: #800080;'>Valve Operated :All Throttle Valves and Others</span>",
      "<span style='color: #800080;'>Pressure Control : Adaptive,PID,Position Set Position</span>",
      "<span style='color:#000;'>Set Position Control (Pressure &Position)</span>"],
    dualThrottleValveTitle: "Dual Throttle Valve",
    dualThrottleValveText: [
      "<span style='color:#000;'>The first is to</span> <span style='color: #800080;'>control two throttle valves with one controller with Master and Slave mode</span>",
      "<span style='color: #800080;'>Master valve is enabled to position and pressure control, slave valve follows the position value of the that of the master's</span>",
      "<span style='color: #800080;'>The latter is to</span> <span style='color:#000;'>control two step motors with one integral throttle valve</span>",
      "<span style='color: #800080;'>For a combination type and blade type throttle valve controls position from one side and pressure is controlled from the other side.</span>",
    ],
    multiPositionControllerTitle: "Multi Position Controller",
    multiPositionControllerText: [
      "<span style='color: #800080;'>Valve Operated:Position Control</span>",
      "<span style='color: #800080;'>Throttle Valve Control:Max 6 Channel</span>",
      "<span style='color: #000;'>Display Windows : 7-Segment &LED Status & Open, Close, Run</span>",
      "<span style='color: #000;'>Set Point Signal RS-232& RS-485 <br>option :D-NET,Ethernet, EtherCAT</span>",
    ],
    mneHeaderText: "MNE 密封圈O-RING <br>FFKM是指全氟化弹性体，比普通氟橡胶含有更多的氟。 ",
    mneTitle: "MNE 密封圈O-RING",
    mneText: "FFKM对温度较高、各种化学物质具有抗性，即使在等离子体存在的环境中也能耐受很长时间。特别是特定等级的过氟橡胶最 多可在327℃下连续使用,基于这些特点,在半导体、石油化学等需要Sealing的多种产业中得到应用。",
    mneImgTextOne: "FFKM,FKM - Orings",
    mneImgTextTwo: "Bonded Slit Valve",
    mneImgTextThree: "C&C Parts",
    mneDownloadTextOne: "MNE Product - Categorized by Process",
    mneDownloadTextTwo: "MNE Product - Categorized FFKM Physical Properties",
    // mneDownloadTextThree: "MNE Product - Categorized FKM Physical Properties",
    mneDownloadTextThree: "MNE 密封圈O-RING",
    unisemChillerText: "Unisem Chiller Product Line-Up",
    unisemChillerTableOneTh: [
      {
        name: "Class"
      },
      {
        name: "Type"
      },
      {
        name: "Pic"
      },
      {
        name: "Features"
      },
      {
        name: "Temp. Range"
      },
      {
        name: "Cooling Capacity"
      },
      {
        name: "Channels"
      },
      {
        name: "Heater"
      },
      {
        name: "Flowrate"
      },
    ],
    unisemChillerTableOneTr: [
      {
        class: "Refrigerant",
        type: "Refrigerant",
        pic: require('../imgs/unisemChillerTableImg1.png'),
        features: "-. All customized Designed <br>-. Various Cooling capacity<br>-. Compact Design & No leak<br>-. Low power consumption",
        tempRange: "-30°C ~ +60°C",
        coolingCapacity: "3Kw ~ 25Kw @ 0°C",
        channels: "Up to 3",
        heater: "1Kw ~ 8Kw",
        flowrate: "Up to 50LPM",
        classF: true,
      },
      {
        class: "",
        type: "Cryogenic",
        pic: require('../imgs/unisemChillerTableImg2.png'),
        features: "-. BLDC for E-Saving<br>-. Cascade system<br>-. No leakage & Freezing",
        tempRange: "-100°C ~ +50°C",
        coolingCapacity: "2Kw @ -100°C<br>7Kw @ -70°C",
        channels: "Up to 2",
        heater: "1Kw ~ 5Kw",
        flowrate: "Up to 30LPM",
        classF: false,
      },
      {
        class: "Combination",
        type: "Hybrid(Mixing, Switching type)",
        pic: require('../imgs/unisemChillerTableImg3.png'),
        features: "-. Fast temp change under same process<br>-. Use mixing unit for frequent tempt change<br>-. Buffer system for increasing cooling capacity <br> <span style='color: red'>-. Size : 600W x 900D x 1800H(3Ch)</span>",
        tempRange: "-30°C ~ +50°C",
        coolingCapacity: "9w~25Kw @ 0℃ <br>8Kw~12Kw @ 80℃",
        channels: "Up to 3",
        heater: "1Kw ~ 16Kw",
        flowrate: "Up to 30LPM",
        classF: true,
      },
      {
        class: "",
        type: "Combination",
        pic: require('../imgs/unisemChillerTableImg4.png'),
        features: "-. Individual Control by channel<br>-. Diagnosis System.",
        tempRange: "-20°C ~ +90°C",
        coolingCapacity: "2kw~15Kw @ 0℃ <br>8Kw~20Kw @ 80℃",
        channels: "Up to 5",
        heater: "1Kw ~ 10Kw",
        flowrate: "Up to 50LPM",
        classF: false,
      },
    ],
    unisemChillerTableTwoTh: [
      {
        name: "Class"
      },
      {
        name: "Type"
      },
      {
        name: "Pic"
      },
      {
        name: "Features"
      },
      {
        name: "Temp. Range"
      },
      {
        name: "Cooling Capacity"
      },
      {
        name: "Channels"
      },
      {
        name: "Heater"
      },
      {
        name: "Flowrate"
      },
    ],
    unisemChillerTableTwoTr: [
      {
        class: "Heat-exchanger",
        type: "Heat-Exchanger",
        pic: require('../imgs/unisemChillerTableImg5.png'),
        features: "-. Customized Designed<br>-. Various cooling Capacity<br>-. Compact Designed<br>-. Low power consumption",
        tempRange: "-30°C~+160°C",
        coolingCapacity: "2w ~ 30Kw @ 50°C",
        channels: "Up to 5 Or Over",
        heater: "1Kw ~ 20Kw",
        flowrate: "Up to 60LPM",
        classF: true,
      },
      {
        class: "",
        type: "Ultra High Temperature",
        pic: require('../imgs/unisemChillerTableImg6.png'),
        features: "-. Stable operation under high temperature status<br>-. Fume Monitoring System<br>-. No leak with gasket<br>-. Diagnosis System",
        tempRange: "50°C ~ +350°C",
        coolingCapacity: "2Kw~40kw @ 150°C",
        channels: "Up to 2",
        heater: "7Kw ~ 60Kw",
        flowrate: "Up to 60LPM",
        classF: false,
      },
      {
        class: "",
        type: "Built-In",
        pic: require('../imgs/unisemChillerTableImg7.png'),
        features: "-. Compact designed for built in tool<br>-. No leakage issue<br>-. Hardware module swap kit<br> <span style='color: red'>-. Size : 230X x 425D x 645H</span>",
        tempRange: "30°C ~ +90°C",
        coolingCapacity: "8Kw @ 50℃",
        channels: "Up to 2",
        heater: "1Kw ~ 5Kw",
        flowrate: "Up to 30LPM",
        classF: false,
      },
      {
        class: "Electric",
        type: "Electric",
        pic: require('../imgs/unisemChillerTableImg8.png'),
        features: "-. Electric Type<br>-. Low power consumption<br>- BLDC pump for E-saving",
        tempRange: "0°C ~ +70°C",
        coolingCapacity: "5Kw @ 35℃",
        channels: "Up to 2",
        heater: "-",
        flowrate: "Up to 30LPM",
        classF: true,
      },
    ],
    aboutPageTitle: "企业愿景",
    aboutPageText: "进一步追求最尖端的技术 <br>        成为全世界真空阀门的领跑者",
    aboutList: [
      {
        title: "佳晟核心价值观",
        text: "以客户为中心，以贡献者为本，坚持开放 协作，坚持批判和自我批判，永远光明正大地行动。"
      },
      {
        title: "佳晟使命",
        text: "提出创造性目标，满怀热情挑战，聚焦客户关注的挑战和压力，提供有 竞争力的全套真空阀门解决方案和服务,持续为客户创造最大的价值。"
      },
      {
        title: "佳晟愿景",
        text: "进一步追求最尖端的技术，成为全世界真空阀门的领跑者。"
      },
      {
        name: "公司简介",
      },
      {
        name: "联系我们",
      },
      {
        name: "佳晟荣誉",
      },
    ],
    CompanyProfile: "公司简介",
    CompanyProfilePageTitle: "靖江佳晟真空技术有限公司创立于2018年",
    CompanyProfilePageText: "专注于半导体高性能真空阀门研发的创新型科技企业。",
    CompanyProfileMainTextOne: "靖江佳晟真空技术有限公司创立于2018年，专注于半导体高性能真空阀门研发的创新型科技企业。在创立之初，佳晟真空与韩国第一真空阀门公司PRESYS深入合作，持续提供赢得客户感谢的产品与服务。近年来，韩国PRESYS派遣最高技术与高品质管理人员常驻中国，加强双方紧密的合作，协助佳晟在中国制造传输阀，插板阀，角阀，RPC阀，蝶阀与摆阀。基于优秀的创新与工程能力，是佳晟真空提供技术与服务解决方案的原动力。",
    CompanyProfileMainTextTwo: "我们技术团队带着“Need company”的使命感，提出创造性目标，满怀热情挑战，致力深耕半导体和平板显示的核心领域， 最终实现突破， 创造了高真空阀门和控制系统的全新技术。 基于这些技术， 我们的真空阀门有幸能够匹配快速发展的中国半导体产业。 拥有如此多的技术突破， 我们有信心成为一家超一流的高真空阀门的中国企业。",
    CompanyProfileMainTextThree: "我们专注于真空技术创新作为我们的核心竞争力。从一开始，的应用、 需求与期望非常了解， 这也是我们开发新产品的基石。 ",
    CompanyProfileMainTextFour: "高效的售后服务是我们的承诺，佳晟真空团队从 2018年开始，与中国客户紧密的合作。",
    CompanyProfileMainTextFive: "佳晟真空产品定制能力表明我们强力聚焦于为客户提供解决方案: 控压阀门、 传输阀、 ATM door、 插板阀、 摆阀与角阀解决方案。",
    CompanyProfileMainTextSix: "我们的优势在于产品可靠性高、 交期短与有经验的技术团队。",
    CompanyProfileMainTextSeven: "我们为所有粗真空(Black Vacuum)到极高真空(Extremely High Vacuum) 的用户提供解决方案。",
    developmentPath: "发展历程",
    developmentPathPageTitle: "DEVELOPMENT HISTORY",
    developmentPathPageText: "靖江佳晟真空技术有限公司创立于2018年<br/>专注于半导体高性能真空阀门研发的创新型科技企业。",
    CareerOpportunities: "工作机会",
    CareerOpportunitiesText: "培养员工的人生价值。提高企业价值，引领真空产业。",
    CareerOpportunitiesPageTitle: "为什么要加入佳晟真空？",
    CareerOpportunitiesPageList: [
      {
        title: "人才发展",
        text: "人才发展是我们的关键战略重点之一，体现了我们对员工的承诺。我们深知投资员工才是我们长期成功的关键。我们会根据人才管理和继任规划，为员工量身定制行动方案，从而促进人才发展和成长。我们大力支持员工领导力的培养和技术的发展，鼓励员工更深入、更广泛地探索我们的业务。"
      },
      {
        title: "成长才能创造机会",
        text: "在佳晟真空这样一家成功且不断成长的公司工作，意味着您将会有很多机会接触到具有挑战性的任务以及变革性项目。如果没有人才，我们就无法拓展新的产品线、业务、领域或市场。我们寻找人才的第一个地方就是我们自己的队伍。您会在我们公司找到许多成长机会。"
      },
      {
        title: "个人职业发展",
        text: "为佳晟真空工作意味着为一家快节奏、激动人心并且具有协作精神的公司工作。您将有机会参与打造产品、公司和自己的职业生涯。这里没有僵化的预先定义的职业道路在我们的支持下，您将有机会用自己的方式来加溪或拓空经验，在职业道路上不断前进。如果您希望在下一份工作中有所作为佳婎员館跟溲酈漾斑绝对是正确的选择。"
      },
    ],
    recruitment: "招聘岗位",
    seeMoreRecruitment: "查看更多招聘岗位",
    recruitmentText: "培养员工的人生价值。提高企业价值，引领真空产业。",
    recruitmentList: [
      {
        name: "部门：高真空事业部",
        isShow: true,
        list: [
          {
            type: "招聘岗位:",
            typeText: "组装",
            planPeople: "计划人员:",
            planPeopleText: "5名",
            job: "岗位职责:",
            jobText: "半导体，面板显示，光伏行业高真空阀门的组装; <br>" +
              "能够看懂机械装配图纸，熟悉组装，装配钳工工艺，依据生产计别，做好生产辅助工作;<br>" +
              "做好影件检验、清理、配料等严格按工艺要求进行组装，保证间门装配质量，合理使用工具，做到安全提作，文明生产，维护工作区域内的整洁，设备工具归位，完成其他相关工作。",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>5000-7000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "主管",
            planPeople: "计划人员:",
            planPeopleText: "1名",
            job: "岗位职责:",
            jobText: "负贵制定和着实生产计划，并监督生产计划的执行情况，确保生产进度和产品质量; <br>" +
              "负责生产现场管理和生产质量控制，确保生产现场符合公司要求、生产过程符合标准;<br>" +
              "负责生产人员的日常管理和培训，提高员工技能和生产效率;<br>" +
              "负责生产设备的维护和管理，确保生产设备的正常运行;<br>" +
              "协助其他部门完成相关任务，如与其他部门协作完成采购、物流、质量检验等任务，自觉通守公司各项规章制度，服从领导安排的其它相关工作。",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>10000-15000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "来料检验员",
            planPeople: "计划人员:",
            planPeopleText: "2名",
            job: "岗位职责:",
            jobText: "负肯阀门来料进行外观检查，确保零部件符合外观质量要求; <br>" +
              "及时汇报不台格的零部件;<br>" +
              "对待不合格的零件委有完整的记录，方便查询不合格原因;<br>" +
              "负责维护工作区域的整洁，保证工作环境有序;<br>" +
              "完成上级领导安排的工作任务。",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>4500-6000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "测试技工",
            planPeople: "计划人员:",
            planPeopleText: "2名",
            job: "岗位职责:",
            jobText: "按照测试计划和测试方案，对产品进行测试，并记录测试结果; <br>" +
              "对测试过程中发现的缺陷进行详细记录，并及时反馈给开发人员;<br>" +
              "跟踪缺陷修复情况:对已报告的缺陷进行跟踪，确保其得到及时修复;<br>" +
              "对测试过程和结果进行总结，形成测试报告，为产品评估和改进供依据。",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>5000-7000元</span>",
          },
        ]
      },
      {
        name: "部门：研发部",
        isShow: false,
        list: [
          {
            type: "招聘岗位:",
            typeText: "翻板阀开发人员",
            planPeople: "计划人员:",
            planPeopleText: "1名",
            job: "岗位职责:",
            jobText: "负责真空阀门设计与开发工作，负责机械总体方案、机械结构设计以及3D/2D绘图; <br>" +
              "负责协助产品研发的质量达成;<br>" +
              "负责新品标准规范资料的制作;<br>" +
              "负责新品样机装配、调试，并配合做验证工作;<br>" +
              "负责完成上级交办的临时工作。",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>15000-20000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "仿真工程师",
            planPeople: "计划人员:",
            planPeopleText: "2名",
            job: "岗位职责:",
            jobText: "负责阀门机械结构分析与运动学、动力学求解、减振设计、公差分析及流导分析等; <br>" +
              "负责协助产品研发的质量达成;<br>" +
              "负责新品标准规范资料的制作;<br>" +
              "负责完成上级交办的临时工作。",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>15000-20000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "传输阀开发人员",
            planPeople: "计划人员:",
            planPeopleText: "1名",
            job: "岗位职责:",
            jobText: "负责真空阀门设计与开发工作，负责机械总体方案、机械结构设计以及3D/2D绘图; <br>" +
              "负责协助产品研发的质量达成;<br>" +
              "负责新品标准规范资料的制作;<br>" +
              "负责新品样机装配、调试，并配合做验证工作;;<br>" +
              "负责完成上级交办的临时工作。",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>15000-20000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "蝶阀开发人员",
            planPeople: "计划人员:",
            planPeopleText: "1名",
            job: "岗位职责:",
            jobText: "负责真空阀门设计与开发工作，负责机械总体方案、机械结构设计以及3D/2D绘图; <br>" +
              "负责协助产品研发的质量达成;<br>" +
              "负责新品标准规范资料的制作;<br>" +
              "负责新品样机装配、调试，并配合做验证工作;<br>" +
              "负责完成上级交办的临时工作。",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>15000-20000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "I-MOTION开发人员",
            planPeople: "计划人员:",
            planPeopleText: "2名",
            job: "岗位职责:",
            jobText: "负责真空阀门设计与开发工作，负责机械总体方案、机械结构设计以及3D/2D绘图，负责结构的力学及受力分析，负责结构的运动仿真; <br>" +
              "负责协助产品研发的质量达成;<br>" +
              "负责新品标准规范资料的制作;<br>" +
              "负责新品样机装配、调试，并配合做验证工作;;<br>" +
              "负责完成上级交办的临时工作。",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>15000-20000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "嵌入式软件工程师",
            planPeople: "计划人员:",
            planPeopleText: "1名",
            job: "岗位职责:",
            jobText: "负责真空控制阀门嵌入式软件开发、调试、验证工作;<br>" +
              "负责产品技术文档编写。",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>15000-20000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "测试工程师",
            planPeople: "计划人员:",
            planPeopleText: "1名",
            job: "岗位职责:",
            jobText: "负责产品总体测试策略、可靠性测试策略制定，测试计划制定及测试用例设计;<br>" +
              "负责产品测试交付，包括产品单元测试、功能测试、集成测试。" +
              "负责新品样机调试，验证，利用实验室测试数据找出关键性能值" +
              "生产现场支持、产品问题分析与解决、客户现场支持等工作。" +
              "负责新品标准规范资料的制作。"+
              "负责完成上级交办的临时工作。",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>15000-20000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "控制阀研发工程师(摆阀)",
            planPeople: "计划人员:",
            planPeopleText: "1名",
            job: "岗位职责:",
            jobText: "负责真空阀门设计与开发工作，负责机械总体方案、机械结构设计以及3D/2D绘图，负责机械结构分析与运动学、动力学求解、减振设计、公差分析等;<br>" +
              "负责协助产品研发的质量达成。<br>" +
              "负责新品标准规范资料的制作。<br>" +
              "负责新品样机装配、调试，并配合做验证工作。<br>" +
              "负责完成上级交办的临时工作。<br>",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>15000-20000元</span>",
          },
        ]
      },
      {
        name: "部门：制造部",
        isShow: false,
        list: [
          {
            type: "招聘岗位:",
            typeText: "加工中心(立加)",
            planPeople: "计划人员:",
            planPeopleText: "8名",
            job: "岗位职责:",
            jobText: "能够独立操作斗山立式加工中心，熟悉常用的刀具、量检具，会工装夹具的安装和拆卸，熟悉零件的拉直、分中、对刀等常规操作;<br>" +
              "负责设备的日常保养维护;<br>" +
              "负责区域内的5S;<br>" +
              "负责每日的产值目标及质量目标的达成。<br>",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>7000-11000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "加工中心(卧加龙门)",
            planPeople: "计划人员:",
            planPeopleText: "3名",
            job: "岗位职责:",
            jobText: "能够独立操作星视野立式龙加工中心，熟悉常用的刀具量检具，会工装夹具的安装和拆卸，熟悉零件的拉直、分中、对刀等常规操作;<br>" +
              "负责设备的日常保养维护;<br>" +
              "负责区域内的5S;<br>" +
              "负责每日的产值目标及质量目标的达成。<br>",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>8000-13000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "数控车操作工",
            planPeople: "计划人员:",
            planPeopleText: "5名",
            job: "岗位职责:",
            jobText: "能够独立操作斗山立式、卧式或云机车床，熟悉常用的刀具、量检具，能够独立编写简单的车加工程序;<br>" +
              "负责设备的日常保养维护;<br>" +
              "负责区域内的5S;<br>" +
              "负责每日的产值目标及质量目标的达成。<br>",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>8000-13000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "机修工",
            planPeople: "计划人员:",
            planPeopleText: "1名",
            job: "岗位职责:",
            jobText: "能够独立解决机械故障，具有电气方面的知识，了解生产环境因素和相关的工厂安全消防知识;<br>" +
              "负责全公司机械设备的维护和保养工作，对车间员工设备日常保养工作进行监督，并填写记录;<br>" +
              "建立设备维修台账，按照既定计划进行设备的检修和维护;<br>" +
              "根据车间生产任务的安排，快速处理产线设备异常，确保生产有序进行;<br>" +
              "负责新设备的验收工作，以及相应的设备水电气的安装和调试。",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>5000-7000元</span>",
          },
        ]
      },
      {
        name: "部门：质量部",
        isShow: false,
        list: [
          {
            type: "招聘岗位:",
            typeText: "巡检",
            planPeople: "计划人员:",
            planPeopleText: "2名",
            job: "岗位职责:",
            jobText: "每天检验前确认现场员工使用的检具，替换不良、损检具，并指导员工正确的使用、保养检具;<br>" +
              "监督生产员工的设备点检、自主检验及自助检测的准确性，并指导、监督员工完成;<br>" +
              "确认现场首件及员工首件检测数据，填写交接班记录，发现异常及时反馈部门主管、接班人员;<br>" +
              "配合现场调机、停机、换刀后的首件尺寸，协助部门主管对车间不良品或不良现象进行跟踪记录;<br>" +
              "部门安排的其他临时任务。",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>5000-7000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "体系工程师",
            planPeople: "计划人员:",
            planPeopleText: "1名",
            job: "岗位职责:",
            jobText: "对体系的策划、推行、维护、改进和推行过程中的监督管理等;<br>" +
              "组织实施公司内部体系、过程和产品审核，负责客户审核陪同及文件资料收集、准备、审核问题跟踪关闭;<br>" +
              "负责组织质量体系文件编制、修订、培训、发放及管理;<br>" +
              "组织开展对公司计量仪器、档案等管理;<br>" +
              "部门安排的其他临时任务。",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>6000-12000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "质量工程师",
            planPeople: "计划人员:",
            planPeopleText: "1名",
            job: "岗位职责:",
            jobText: "实施部门及年度质量计划，对每月内外部质量问题进行分析总结;<br>" +
              "负责客户投诉，并快速反应，将失效异常反馈至内部，短期内解决客户端的问题，跟踪改善措施直至问题关闭;<br>" +
              "参与新品开发前期质量策划，中期质量管控以及后期质量保证;<br>" +
              "对产生的不良品进行初判、分析、改进和效果验证，并对IQC、POC、0QC日常工作管理;<br>" +
              "部门安排的其他临时任务。",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>6000-12000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "质量总监",
            planPeople: "计划人员:",
            planPeopleText: "1名",
            job: "岗位职责:",
            jobText: "负责企业整体质量战略的拟定，配合企业发展战略的需要全面负责质量管理工作;<br>" +
              "制定质量控制的政策、流程、制度及操作规范，督促、检查质量制度流程的贯彻执行;<br>" +
              "指导IS016949质量管理体系的建设，在组织人员对其进行审核保证有效控制运行;<br>" +
              "主持召开重大质量专题会议，协调各部门的配合，开展重大质量改善和成本降低项目;<br>" +
              "主持重大质量风险和事故的处理，协助处理客诉与退货，制定改善措施; <br>" +
              "负责供应链的质量控制，对关键物料的供货质量进行控制管理。",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>20000-40000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "检验员",
            planPeople: "计划人员:",
            planPeopleText: "3名",
            job: "岗位职责:",
            jobText: "接收仓库的来料检验通知、制程中首/末件、半/成品以及销售部的发货计划单，根据检验规范、图纸等进行检验;<br>" +
              "检验结束后准确出具检测报告，对测量结果负责，并对检验记录进行整理存档，检验合格后按流程报工，过程中发现异常及时反馈;<br>" +
              "根据检验发现的问题汇总，并及时开出不良通知;<br>" +
              "部门安排的其他临时任务。",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>4500-6000元</span>",
          },
        ]
      },
      {
        name: "部门：制造工程部",
        isShow: false,
        list: [
          {
            type: "招聘岗位:",
            typeText: "CNC编程",
            planPeople: "计划人员:",
            planPeopleText: "1名",
            job: "岗位职责:",
            jobText: "负责零件的加工中心工艺分析、材料评估、刀具评估;<br>" +
              "负责程序编写、模拟仿真并输出相关G代码、程序单、刀单等;<br>" +
              "负责优化已加工零件工艺、程序、提高效率;<br>" +
              "负责处理车间反馈的一些调试问题，对不合理的程序进行修改。" ,
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>:8000-16000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "工艺工程师",
            planPeople: "计划人员:",
            planPeopleText: "1名",
            job: "岗位职责:",
            jobText: "对新产品的图纸进行工艺设定，编制工艺文件，制作加工工艺流程;<br>" +
              "跟踪产品工艺过程，对车间工艺执行情况进行检查，对违反工艺纪律的行为进行制止;<br>" +
              "对工艺文件、工装图纸进行改进，对制订的工艺文件负责解释，对不符合图纸的工艺文件进行纠正;<br>" +
              "对报价项目的零件及时评估产品的加工工艺及工时。" ,
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>8000-16000元</span>",
          },
          {
            type: "招聘岗位:",
            typeText: "夹具工程师",
            planPeople: "计划人员:",
            planPeopleText: "1名",
            job: "岗位职责:",
            jobText: "工装夹具设计与规范标准化;<br>" +
              "熟练使用NX(UG)软件，3D建模、2D制图;<br>" +
              "数控编程基础，机械加工工艺基础;<br>" +
              "了解液压、气动夹具原理;<br>" +
              "EXCEL基础操作。",
            salary: "薪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资:",
            salaryText: "<span style='color: #6C2188'>10000-15000元</span>",
          },
        ]
      },
    ],
    ConsultationImmediately: "立即咨询",
    contactUsText: "我们在这里为你服务",
    contactUsTexts:"联系我们。",
    contactUsList: [
       {
         // title: "销售部经理",
         title: "客户经理",
         // titleText: "/ 负责人",
         titleText: "",
         name: "闻先生 / Mr.Wen",
         phone: "+86 151 8992 0371",
         email: "wenshuai@jiashengvac.com ",
         // address: "江苏省靖江市经济开发区新业路9号",
         address: "常驻地：江苏"
       },
      {
        title: "客户经理",
        titleText: "",
        name: "展女士 / Ms.Zhan",
        phone: "+86 151 8993 0567",
        email: "zhanwenjun@jiashengvac.com",
        // address: "北京市经济技术开发区文昌大道8号",
        address: "常驻地：北京"
      },
      {
        title: "客户经理",
        titleText: "",
        name: "蔡先生 / Johnson",
        phone: "+86 152 1661 3109",
        email: "johnson@jiashengvac.com",
        // address: "北京市经济技术开发区文昌大道8号",
        address: "常驻地：上海"
      },
    ],
    select_list: [
      {
        name: "Mr.",
      },
      {
        name: "Ms.",
      },
    ],
    leaveUsMessage: "给我们留言",
    leaveUsMessages: "请通过下面的表单向我们发送快速留言，我们会尽快回复您。",
    call: "称呼：",
    pleaseChoose:"请选择。",
    choose: "选择",
    name: "名：",
    notEmpty: "不能为空。",
    lastname: "姓：",
    dept: "公司：",
    department: "部门：",
    emailC: "电子邮箱：",
    emailText: "必须是有效的电子邮件地址。",
    phone: "电话：",
    CountryRegion: "国家/地区：",
    Topic:"主题：",
    YourMessage:"您的留言：",
    UploadFiles: "上传文件",
    cText: "最大可上传文件大小: 15 MB，仅接受 JPG、PNG、CAD 和 PDF 文件。",
    cText2: "本人同意让此网站存储本人提交的信息，以便其可以回复本人的询价。",
    sendMessage: "发送信息",

    jszkMemberLogin: "佳晟真空会员登录",
    memberLogin: "会员登录",
    userNameRequired: "请输入用户名",
    passWordRequired: "请输入密码",
    login: "登录",
    forgetPassword: "忘记密码",
    notMember: "还未成为会员",
    quicklyRegister: "快速注册",
    jszkMemberRegistration: "佳晟真空会员注册",
    registered: "企业注册",
    registeredText1: "已有账号，去",
    registeredText2: "登录",
    registeredList: [
      {
        name: "企业名称：",
        text: "请输入企业名称",
        required: "请输入企业名称",
      },
      {
        name: "手机号码：",
        text: "请输入手机号或邮箱",
        required: "请填写您用来登录的账号",
      },
      {
        name: "验&nbsp;&nbsp;&nbsp;证&nbsp;&nbsp;码：",
        text: "请输入验证码",
        button: "获取验证码",
        reP: "重新发送",
      },
      {
        name: "真实姓名：",
        text: "请填写您的真实姓名",
      },
      {
        name: "设置密码：",
        text: "设置密码",
        required: "大于6个字符小于20个字符的字母或数字",
      },
      {
        name: "确认密码：",
        text: "确认密码",
        required: "再次输入您的密码确认",
      },
    ],
    readAndAgree: "阅读并同意",
    protocol: "《佳晟真空网站服务协议》",
    register: "注册",
    registerContent: "恭喜您，注册成功",
    registerContentBtn: "下载文件",
    retrievePasswordText: "佳晟真空会员忘记密码",
    retrievePassword: "忘记密码",
    retrieveList: [
      {
        name: "注册时企业名称：",
        text: "请输入企业名称",
        required: "请填写企业全称",
      },
      {
        name: "注册时手机号码：",
        text: "请输入手机号或邮箱",
        required: "请填写您用来登录的账号",
      },
      {
        name: "真实姓名：",
        text: "请填写您的真实姓名",
      },
      {
        name: "设置新密码：",
        text: "设置密码",
        required: "大于6个字符小于20个字符的字母或数字",
      },
      {
        name: "确认新密码：",
        text: "确认密码",
        required: "再次输入您的密码确认",
      },
      {
        name: "验&nbsp;&nbsp;&nbsp;证&nbsp;&nbsp;码：",
        text: "请输入验证码",
        button: "获取验证码",
        reP: "重新发送",
      },
    ],
    confirm: "确认",
    honorText1: "企业荣誉证书、专利证书",
    honorText2: "荣誉证书",
    honorText3: "查看",
    honorText4: "专利证书",
    backNews: "返回新闻资讯",
    checkText: "请勾选选项",
    loginSuccess: "登录成功",
    retrievePasswordTextR: "修改密码成功",
    uploadSuccess: "上传成功",
    contactUsChoose: "选择国家/地区",
    // https:'http://a34.madpay.com',
    https: 'https://www.jiashengvac.com',
    // https: 'http://admin.jiashengvac.com',
    bannerBg1: require('../imgs/bannerBg1.png'),
    bannerBg2: require('../imgs/bannerBg2.png'),
    bannerBg3: require('../imgs/bannerBg3.png'),
    bannerBg4: require('../imgs/bannerBg4.png'),
    bannerBg5: require('../imgs/bannerBg5.png'),
    bannerBg6: require('../imgs/bannerBg6.png')
  }
};



// WEBPACK FOOTER //
// ./src/assets/lang/zh.js